
let names = {};
let components = {};
const requireComponents = require.context('./', true, /[\w]+\.vue$/)

requireComponents.keys().forEach(fileName => {
    const iconName = fileName.replace(/^\.\/(solid|outline)\/Icon(.+)(Solid|Outline)\.vue/, '$2')
    const solid = fileName.match(/^\.\/solid\/Icon/)
    const componentConfig = requireComponents(fileName)
    names[iconName] = true;
    components[`Icon${iconName}${solid?'Solid':'Outline'}`] = componentConfig.default || componentConfig
})

names = Object.keys(names)

module.exports = { names, components };
